"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _withSidebar = _interopRequireDefault(require("./withSidebar.png"));
var _Settings = _interopRequireDefault(require("./Settings"));
var _Mediator = _interopRequireDefault(require("./Mediator"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = {
  handle: 'withSidebar',
  label: 'Sidebar',
  thumbnail: _withSidebar["default"],
  settingsComponent: _Settings["default"],
  mediatorComponent: _Mediator["default"]
};